// extracted by mini-css-extract-plugin
export var agendaH4 = "agenda-module--agendaH4--a0630";
export var bloc = "agenda-module--bloc--611e9";
export var containerDate = "agenda-module--containerDate--ef400";
export var containerTitle = "agenda-module--containerTitle--8ae96";
export var h1 = "agenda-module--h1--7325e";
export var h1_hover = "agenda-module--h1_hover--024f1";
export var h2 = "agenda-module--h2--3ab70";
export var h2_hover = "agenda-module--h2_hover--3152c";
export var h3 = "agenda-module--h3--b3972";
export var h4 = "agenda-module--h4--19f7d";
export var hover = "agenda-module--hover--39faa";
export var innerBloc = "agenda-module--innerBloc--ca0eb";
export var itemMainBloc = "agenda-module--itemMainBloc--5f111";
export var link = "agenda-module--link--3945b";
export var mainBloc = "agenda-module--mainBloc--5b742";
export var nbLines = "agenda-module--nbLines--613fb";
export var titleAgenda = "agenda-module--titleAgenda--fe5e5";